// Behaviors
require("./behaviors/01.image-bg");
require("./behaviors/02.anchor-link");
require("./behaviors/03.fancybox");
require("./behaviors/04.slide");
require("./behaviors/05.header-fixed");
require("./behaviors/06.box-carousel-products");
require("./behaviors/06.box-gallery-carousel");
require("./behaviors/07.menu");
require("./behaviors/08.tables-responsive");
require("./behaviors/09.box-carousel-testimony");
require("./behaviors/10.random-whatsapp");
require("./behaviors/20.masks");
